import React from 'react'
import databaseSolid from "../../logo/database-solid.svg";
import shieldHalvedSolid from "../../logo/shield-halved-solid.svg";
import tableColumnsSolid from "../../logo/table-columns-solid.svg";
import peopleGroupSolid from "../../logo/people-group-solid.svg";
import { usePublicSiteId } from '../../contexts/PublicSiteContext';
import type { PublicSiteId } from '../../utils/publicSite';

interface FeatureItem {
  title: string;
  description: string;
  icon: string;
}

const storageWalkFeatures: FeatureItem[] = [
    {
        title: "Interactive Dashboard",
        description: "Log in to see a comprehensive overview of all your facilities. Filter by date, issue type or location for detailed insights.",
        icon: tableColumnsSolid
    },
    {
        title: "Collaborative Tools",
        description: "Share notes and tasks directly from the app. Assign follow-up actions to team members with deadlines and priority levels.",
        icon: peopleGroupSolid
    },
    {
        title: "Historical Data",
        description: "Review past walks and track improvements or recurring issues over time, helping in predictive maintenance and resource allocation.",
        icon: databaseSolid
    },
    {
        title: "Security First",
        description: "With end-to-end encryption, your data is secure from the moment it's captured until it's reviewed.",
        icon: shieldHalvedSolid
    }
]

const patrolWalkFeatures: FeatureItem[] = [
    {
        title: "Interactive Dashboard",
        description: "Log in to see a comprehensive overview of all your patrol sites. Filter by date, incident type or location for detailed insights.",
        icon: tableColumnsSolid
    },
    {
        title: "Collaborative Tools",
        description: "Share notes and incident reports directly from the app. Assign follow-up actions to patrol officers with deadlines and priority levels.",
        icon: peopleGroupSolid
    },
    {
        title: "Historical Data",
        description: "Review past patrols and track improvements or recurring incidents over time, helping in resource allocation and coverage planning.",
        icon: databaseSolid
    },
    {
        title: "Security First",
        description: "With end-to-end encryption, your patrol data is secure from the moment it's captured until it's reviewed.",
        icon: shieldHalvedSolid
    }
]

const constructionWalkFeatures: FeatureItem[] = [
    {
        title: "One Mobile Workflow",
        description: "Employees, foremen, superintendents, operations and payroll all work from the same platform—no separate apps or duplicate entry.",
        icon: peopleGroupSolid
    },
    {
        title: "Accounting Integration",
        description: "Removes duplicate entry between jobsite records and your accounting system. Approved field time posts into Sage 100 Contractor or QuickBooks Online without rekeying.",
        icon: tableColumnsSolid
    },
    {
        title: "Defensible Daily Record",
        description: "Creates a time-stamped daily record for disputes, changed conditions, safety documentation and progress tracking.",
        icon: databaseSolid
    },
    {
        title: "Exception-Driven Payroll",
        description: "Makes payroll review exception-driven instead of inspecting every timecard. Focus on corrections, not routine approvals.",
        icon: shieldHalvedSolid
    }
]

function getFeatures(siteId: PublicSiteId): FeatureItem[] {
  switch (siteId) {
    case 'security-walk':
      return patrolWalkFeatures
    case 'construction-walk':
      return constructionWalkFeatures
    default:
      return storageWalkFeatures
  }
}

const Features = () => {
  const siteId = usePublicSiteId();
  const FeatureData = getFeatures(siteId);

  return (
    <div className="w-full mx-auto py-20 px-6 bg-marketing-muted">
        <div className="flex justify-center flex-col">
            <div className="flex tracking-wide md:text-3xl xs:text-2xl justify-center font-semibold text-marketing-ink">
                Features that Make a Difference
            </div>
            <div className="flex justify-center">
            <ul className="flex w-full justify-center py-12 flex-wrap">
                {FeatureData.map((item, index) => (
                    <div key={index} className="flex items-center flex-col xs:w-3/4 sm:w-1/3 lg:w-1/5 py-12 my-4  mx-4 text-white bg-marketing-accent">
                        <img src={item.icon} alt={item.title} className="w-10 h-8 mb-4" style={{color: "white"}}/>
                        <li className="text-lg font-bold px-2 text-center"> {item.title} </li>
                        <li className='flex py-2 items-start justify-center h-full text-center mt-2 px-4'> {item.description} </li>
                    </div>
                ))}
            </ul>
        </div>
        </div>
        
    </div>
  )
}

export default Features
